import appApi from '../../../../../api/app-api';
import { InstallmentReportRow } from '../../../../../api/types/reports/accountant/installment.type';
import { InstallmentsSideBarFilterType } from '../side-bar/installments-side-bar-filter.type';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';
import { toast } from 'react-toastify';

// Helper function to get the start of a month
const getMonthStart = (date: Date): string => {
  const year = date.getFullYear();
  const month = date.getMonth();
  const startDate = new Date(year, month, 1);
  return startDate.toISOString();
};

// Helper function to get the end of a month
const getMonthEnd = (date: Date): string => {
  const year = date.getFullYear();
  const month = date.getMonth();
  const endDate = new Date(year, month + 1, 0);
  return endDate.toISOString();
};

export const getReportInstallmentsOperation = async (
  filters: InstallmentsSideBarFilterType,
  offset: number,
  limit: number,
  setData: (data: InstallmentReportRow[]) => any,
  setTotal: (total: number) => any,
  setLoading: (loading: boolean) => any,
) => {
  try {
    setLoading(true);

    // Calculate start date from startMonth and end date from endMonth
    let startDate: string | null = null;
    let endDate: string | null = null;

    if (filters.startMonth) {
      startDate = getMonthStart(filters.startMonth);
    }

    if (filters.endMonth) {
      endDate = getMonthEnd(filters.endMonth);
    }

    const res = await appApi.getInstallmentsReport({
      startDate,
      endDate,
      paymentStatus: filters.paymentStatuses,
      branchIds: filters.branchIds,
      includeUnassignedBranches: filters.includeUnassignedBranches,
      offset,
      limit,
    });

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }

    setData(res.data.body.data);
    setTotal(res.data.body.total);
    setLoading(false);
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
